<template>
    <jet-dialog-modal 
        :show="modalOpen"
        @close="$emit('close')"
        max-width="6xl"
        ref="modal"
    >
        <template #content>
            <h2 class="text-xl mb-2">
                <template v-if="!editMode">
                    Send A Message
                </template>
                <template v-else-if="editMode">
                    Edit Message
                </template>
            </h2>
            <message-form 
                :md="md"
                class="modal-message-form-wrapper"
                @success="$emit('close')"
            />
        </template>

        <template #footer>
            <button @click="$emit('close')">
                Cancel
            </button>
        </template>
    </jet-dialog-modal>
</template>

<script>
import JetDialogModal from '../Jetstream/DialogModal';
import MessageForm from '../components/MessageForm';
export default {
    props: ['modalOpen', 'md'],
    emits: ['close'],
    components: {
        JetDialogModal,
        MessageForm
    },
    data: () => ({
        editMode: false,
    }),
    mounted( ) {
        if (this.md) {
            this.editMode = true;
        }
    }
}
</script>
